import React, { useState, useEffect } from 'react'
import { useLocation, Link } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import loading from "../../assets/images/common/loading.gif";
import DataTable from "react-data-table-component";
import AppDataGrid from '../../components/common/AppDataGrid';

const StudenthistoryReports = () => {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const routeLocation = useLocation();
    const [sections, setSection] = useState([]);
    const [classes, setClasses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [studenthistorysmaps, setStudenthistorymap] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [submit, setIsSubmitting] = useState(false);
    const [records, setRecords] = useState([]);
    const [column, setColumns] = useState([])

    useEffect(() => {
        if (studenthistorysmaps && studenthistorysmaps.length > 0) {
            setRecords(studenthistorysmaps);
            setColumns(prev =>
                prev.map(col => ({ ...col, hide: false }))
            );
        } else {
            setRecords([]);
        }
        setIsLoading(false);
    }, [studenthistorysmaps]);

    const [form, setForm] = useState({
        class_id: 0,
        section_id: 0,
        roll_no: "",
        userid: 0,
        username: "",
        father_phone_number: "",
        school_id: userObj.school_id,
        admission_number: "",
    });

    const fetchDropdownData = async (endpoint, setter) => {
        try {

            const response = await axios.post(baseUrl + endpoint, { action: 'READ', school_id: userObj.school_id });
            setter(response.data);
        } catch (error) {
            console.error(`Error fetching ${endpoint}:`, error);
        }
    };
    useEffect(() => {
        if (form.class_id != 0) {
            fetchSections(form.class_id || 0);
        }
        else {
            setSection()
        }
    }, [form.class_id]);
    const fetchSections = async (class_id) => {
        try {
            const response = await axios.post(baseUrl + "/Sections/", {
                action: "DROPDOWNREAD",
                school_id: userObj.school_id,
                class_id: class_id,
                academic_year_id:userObj.academic_year_id
            });
            setSection(response.data);
        } catch (error) {
            console.error("Error fetching section: ", error);
        }
    };

    useEffect(() => {
        fetchDropdownData('/classes/', setClasses);

        const matched = routeLocation.state?.matchedStudents;

        if (matched && matched.length > 0) {
            setStudenthistorymap(matched);
            setRecords(matched);
            toast.success("Showing matched records!", { position: "top-right" });
        } else if (matched && matched.length === 0) {
            toast.error("No matched records found!", { position: "top-right" });
        } else if (routeLocation.state?.studenthistoryData) {
            setForm(routeLocation.state.studenthistoryData);
        }
    }, [routeLocation]);

    const formatDate1 = (datetime) => {
        if (!datetime) return "";
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (id === "roll_no" || id === "father_phone_number") {
            if (/^\d*$/.test(value)) {
                const cleanedValue = value.replace(/^0+/, "");
                setForm((prevForm) => ({
                    ...prevForm,
                    [id]: cleanedValue,
                }));
            }
        } else {
            setForm((prevForm) => ({
                ...prevForm,
                [id]: value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        if (!form.admission_number && !form.class_id && !form.section_id && !form.firstname && !form.surname && !form.roll_no && !form.father_phone_number) {
            toast.warning("Please select at least one field to proceed.");
            return;
        }
        const formData = {
            class_id: form.class_id,
            section_id: form.section_id,
            fname: form.firstname,
            lname: form.surname,
            admission_number: form.admission_number,
            roll_no: (form.roll_no && parseInt(form.roll_no) > 0) ? parseInt(form.roll_no) : undefined,
            father_phone_number: form.father_phone_number,
            school_id: userObj.school_id,
            academic_year_id: userObj.academic_year_id,
            action: 'FILTER'
        };
        try {
            const response = await axios.post(baseUrl + "/student_master_filter_report/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.data && response.data.length > 0) {
                setStudenthistorymap(response.data);
                toast.success("Data fetched successfully!", { position: "top-right" });
            } else {
                toast.warning("No records found matching your search criteria.", { position: "top-right" });
            }
        } catch (error) {
            if (error.response) {
                const { status, data } = error.response;
            } else {
                console.error("There was an error submitting:", error);
                toast.error("Error submitting data: " + error.message, { position: "top-right" });
            }
        }
    };

   const columns = [
  {
    field: 'admission_number',
    headerName: 'Admission No',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'student_id',
    headerName: 'Student Id',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    hide: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'student_name',
    headerName: 'Student Name',
    flex: 2,
    headerAlign: 'center',
    align: 'left',
    sortable: true,
    renderCell: (params) =>
      params.row.student_id !== "No Records Found" ? (
        <Tooltip title={`${params.row.student_first_name} ${params.row.student_last_name}`}>
          <Link
            to={`/StudentDetails/${params.row.student_id}`}
            state={{ 
              action: "FILTER", 
              school_id: userObj.school_id, 
              student_id: params.row.student_id,
              activeTab: "Attendance"
            }}
            style={{ color: 'blue', textDecoration: 'none' }}
            onClick={() => setIsLoading(true)}
          >
            {`${params.row.student_first_name} ${params.row.student_last_name}`}
          </Link>
        </Tooltip>
      ) : (
        <span></span>
      ),
  },
  {
    field: 'roll_no',
    headerName: 'Roll No',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'dob',
    headerName: 'DOB',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => {
      const value = formatDate1(params.value);
      return (
        <Tooltip title={value}>
          <span>{value}</span>
        </Tooltip>
      );
    },
  },
  {
    field: 'date_of_join',
    headerName: 'Admission Date',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => {
      const value = formatDate1(params.value);
      return (
        <Tooltip title={value}>
          <span>{value}</span>
        </Tooltip>
      );
    },
  },
  {
    field: 'class_name',
    headerName: 'Current Class',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'section_name',
    headerName: 'Current Section',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'father_phone_number',
    headerName: 'Mobile Number',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
  },
  {
    field: 'father_name',
    headerName: 'Father Name',
    flex: 1.5,
    headerAlign: 'center',
    align: 'left',
    sortable: true,
    renderCell: (params) => {
      const name = `${params.row.father_firstname ?? ''} ${params.row.father_surname ?? ''}`.trim();
      return <span>{name || ''}</span>;
    },
  },
  {
    field: 'mother_name',
    headerName: 'Mother Name',
    flex: 1.5,
    headerAlign: 'center',
    align: 'left',
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.row.mother_firstname || ''}>
        <span>{params.row.mother_firstname || ''}</span>
      </Tooltip>
    ),
  },
];


    return (
        <div className='pageBody'>
            <ToastContainer />
            <Container fluid>
                <div className=''>
                    <Card>
                        <Card.Body className="hide-scrollbar">
                            <form className="" onSubmit={handleSubmit}>
                                <div className=''>
                                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                        <h6 className="commonTableTitle">Student 360</h6>
                                    </div>
                                    <Row>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>Admission Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        id="admission_number"
                                                        value={form.admission_number}
                                                        placeholder="Enter Admission Number"
                                                        maxLength={20}
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>
                                                        Class
                                                    </Form.Label>
                                                    <select
                                                        className="form-select"
                                                        id="class_id"
                                                        value={form.class_id}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Class</option>
                                                        {(classes || [])
                                                            .filter((classItem) => classItem.is_active === "Active")
                                                            .map((classItem) => (
                                                                <option key={classItem.class_id} value={classItem.class_id}>
                                                                    {classItem.class_name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className="commonInput">
                                                <Form.Group>
                                                    <Form.Label>
                                                        Section
                                                    </Form.Label>
                                                    <select
                                                        className="form-select"

                                                        id="section_id"
                                                        value={form.section_id}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select Section</option>
                                                        {(sections || []).map((sections) => (
                                                            <option key={sections.section_id} value={sections.section_id}>
                                                                {sections.section_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label> First Name </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        id="firstname"
                                                        value={form.firstname}
                                                        placeholder="Enter First Name"
                                                        maxLength={30}
                                                        isInvalid={!/^[A-Za-z\s]*$/.test(form.firstname)}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                            handleInputChange({ target: { id: 'firstname', value } });
                                                        }} />
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label> Surname </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        id="surname"
                                                        value={form.surname}
                                                        placeholder="Enter Surname"
                                                        maxLength={30}
                                                        isInvalid={!/^[A-Za-z\s]*$/.test(form.surname)}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                                            handleInputChange({ target: { id: 'surname', value } });
                                                        }} />
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>Roll Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        id="roll_no"
                                                        value={form.roll_no}
                                                        placeholder="Enter Roll Number"
                                                        onChange={handleInputChange}
                                                        maxLength={15}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>Mobile Number</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        id="father_phone_number"
                                                        value={form.father_phone_number}
                                                        placeholder="Enter Contact No"
                                                        maxLength={10}
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col>
                                            <div className="d-flex justify-content-between mt-3">
                                                <div> </div>
                                                <div>
                                                    <Button
                                                        type="button"
                                                        variant="primary"
                                                        className="btn-info clearBtn me-3"
                                                        onClick={() => {
                                                            setForm({
                                                                class_id: "",
                                                                section_id: "",
                                                                firstname: "",
                                                                surname: "",
                                                                roll_no: "",
                                                                father_phone_number: "",
                                                                admission_number: "",
                                                            });
                                                        }}


                                                    >
                                                        Reset
                                                    </Button>
                                                    <Button type="submit" variant="primary" className="btn-success primaryBtn"> Search </Button>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </form>
                            
                            </Card.Body>
                    </Card>
                    <br></br>
                            <div className="commonTable height100">
                                <div className="tableBody">
                                    {isLoading ? (
                                        <div className="loadingContainer">
                                            <img src={loading} alt="Loading..." className="loadingGif" />
                                        </div>
                                    ) : (
                                       <div style={{ height: 'calc(100vh - 170px)', width: '100%' }}>
  <AppDataGrid
    rows={Array.isArray(records) ? records : []}
    columns={columns}
    getRowId={(row) => row.student_id || `${row.class_name}_${row.section_name}`}
    pageSizeOptions={[10, 20, 50]}
    showToolbar={false}
    hideFooter={records.length === 0}
    density="compact"
    autoHeight={false} 
    maxHeight={500}
    // disableExtendRowFullWidth
    
  />
   {/* <AppDataGrid
                              rows={filteredRecords.length ? filteredRecords : []}
                              columns={columns}
                              getRowId={(row) => row.student_id || `${row.class_name}_${row.section_name}`} 
                              pageSizeOptions={[10, 20, 50]}      // Dropdown options
                              showToolbar={false}
                              pagination
                              density="compact"
                              maxHeight={400}
                          /> */}
</div>


                                    )}
                                </div>
                            </div>
                       
                </div>
            </Container>
        </div>


    );
}
export default StudenthistoryReports;